/**
 * @generated SignedSource<<fc57798d08a1705096b7cb8f4a8ca188>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountId"
  }
],
v1 = {
  "kind": "Literal",
  "name": "orderBy",
  "value": "FLAG_NAME_ASC"
},
v2 = [
  {
    "kind": "Literal",
    "name": "condition",
    "value": {
      "accountId": null
    }
  },
  (v1/*: any*/)
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountFeatureId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flagName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flagValue",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flagType",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flagDescription",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flagValueTxt",
  "storageKey": null
},
v9 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AccountFeatureT",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "storageKey": null
  }
],
v10 = {
  "fields": [
    {
      "kind": "Variable",
      "name": "accountId",
      "variableName": "accountId"
    }
  ],
  "kind": "ObjectValue",
  "name": "condition"
},
v11 = [
  (v10/*: any*/),
  (v1/*: any*/)
],
v12 = [
  (v10/*: any*/)
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountName",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
},
v15 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AccountFeatureT",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v14/*: any*/)
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FeatureFlagManageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Query",
        "kind": "LinkedField",
        "name": "query",
        "plural": false,
        "selections": [
          {
            "alias": "base",
            "args": (v2/*: any*/),
            "concreteType": "AccountFeatureTsConnection",
            "kind": "LinkedField",
            "name": "allAccountFeatureTs",
            "plural": false,
            "selections": (v9/*: any*/),
            "storageKey": "allAccountFeatureTs(condition:{\"accountId\":null},orderBy:\"FLAG_NAME_ASC\")"
          },
          {
            "alias": "account",
            "args": (v11/*: any*/),
            "concreteType": "AccountFeatureTsConnection",
            "kind": "LinkedField",
            "name": "allAccountFeatureTs",
            "plural": false,
            "selections": (v9/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v12/*: any*/),
        "concreteType": "AccountTsConnection",
        "kind": "LinkedField",
        "name": "allAccountTs",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountT",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v13/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FeatureFlagManageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Query",
        "kind": "LinkedField",
        "name": "query",
        "plural": false,
        "selections": [
          {
            "alias": "base",
            "args": (v2/*: any*/),
            "concreteType": "AccountFeatureTsConnection",
            "kind": "LinkedField",
            "name": "allAccountFeatureTs",
            "plural": false,
            "selections": (v15/*: any*/),
            "storageKey": "allAccountFeatureTs(condition:{\"accountId\":null},orderBy:\"FLAG_NAME_ASC\")"
          },
          {
            "alias": "account",
            "args": (v11/*: any*/),
            "concreteType": "AccountFeatureTsConnection",
            "kind": "LinkedField",
            "name": "allAccountFeatureTs",
            "plural": false,
            "selections": (v15/*: any*/),
            "storageKey": null
          },
          (v14/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v12/*: any*/),
        "concreteType": "AccountTsConnection",
        "kind": "LinkedField",
        "name": "allAccountTs",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountT",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v13/*: any*/),
              (v14/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "781969481793e9294b85b79cd8869893",
    "id": null,
    "metadata": {},
    "name": "FeatureFlagManageQuery",
    "operationKind": "query",
    "text": "query FeatureFlagManageQuery(\n  $accountId: UUID\n) {\n  query {\n    base: allAccountFeatureTs(condition: {accountId: null}, orderBy: FLAG_NAME_ASC) {\n      nodes {\n        accountFeatureId\n        flagName\n        flagValue\n        flagType\n        flagDescription\n        flagValueTxt\n        nodeId\n      }\n    }\n    account: allAccountFeatureTs(condition: {accountId: $accountId}, orderBy: FLAG_NAME_ASC) {\n      nodes {\n        accountFeatureId\n        flagName\n        flagValue\n        flagType\n        flagDescription\n        flagValueTxt\n        nodeId\n      }\n    }\n    nodeId\n  }\n  allAccountTs(condition: {accountId: $accountId}) {\n    nodes {\n      accountName\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "78eb50c5b74a38912bded4d4c776887d";

module.exports = node;
